import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Phone } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import SectionHeading from "../components/site/SectionHeading";
import { ServiceIcon } from "../components/site/ServiceIcons";
import { IMG, PHONE_TEL } from "../lib/media";

const Services = () => {
  const { t } = useLang();
  return (
    <div data-testid="page-services">
      <section className="relative pt-40 pb-20 border-b border-white/5 overflow-hidden">
        <img src={IMG.kitchen} alt="" className="absolute inset-0 w-full h-full object-cover opacity-25" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0C]/60 via-[#0A0A0C]/80 to-[#0A0A0C]" />
        <div className="relative container-x">
          <SectionHeading overline={t.services.overline} title={t.services.title} subtitle={t.services.subtitle} />
        </div>
      </section>

      <section className="section-y">
        <div className="container-x grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {t.services.items.map((s, i) => (
            <div
              key={i}
              className="hairline hairline-hover rounded-xl p-7 bg-[#141417] card-lift"
              data-testid={`service-item-${i}`}
            >
              <ServiceIcon index={i} className="w-9 h-9 text-[#0055FF]" />
              <h3 className="mt-6 font-display text-xl text-white">{s.title}</h3>
              <p className="mt-3 text-white/60 text-sm leading-relaxed">{s.desc}</p>
              <Link to="/contact" className="mt-6 inline-flex items-center gap-1 text-sm text-white hover:text-[#0055FF]">
                {t.common.learnMore}
                <ArrowUpRight className="w-3.5 h-3.5" />
              </Link>
            </div>
          ))}
        </div>
      </section>

      <section className="border-t border-white/5 bg-[#0C0C0F]">
        <div className="container-x py-16 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <h3 className="font-display text-2xl md:text-3xl font-light max-w-xl">
            Ready to start? Get a free estimate in 24–48 hours.
          </h3>
          <div className="flex gap-3">
            <a href={`tel:${PHONE_TEL}`} className="btn-primary">
              <Phone className="w-4 h-4" /> {t.common.callNow}
            </a>
            <Link to="/contact" className="btn-ghost">{t.common.requestEstimate}</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
